import SocialProduct from "./SocialProduct";

import "./SocialProduct.scss";

export * from "./SocialProduct.types";

export { SocialProduct };
